import type { ReactNode } from "react";

import {
    LargeVerticalMenu,
    LargeMenuItem,
    TriggerHelpIcon,
} from "@impero-com/ui";
import { useTranslation } from "react-i18next";

interface HelpMenuProps {
    trigger?: ReactNode;
}

export function HelpMenu({ trigger }: HelpMenuProps) {
    const { t } = useTranslation();
    return (
        <LargeVerticalMenu
            triggerComponent={trigger ?? <TriggerHelpIcon />}
            headerLabel={t("HelpMenu_Title")}
        >
            <LargeMenuItem
                titleLabel={t("HelpMenu_HelpCenterTitle")}
                descriptionLabel={t("HelpMenu_HelpCenterDesc")}
                href="https://support.impero.com/knowledge"
            />
            <LargeMenuItem
                titleLabel={t("HelpMenu_ContactTitle")}
                descriptionLabel={t("HelpMenu_ContactDesc")}
                href="https://support.impero.com/knowledge/kb-tickets/new"
            />
            <LargeMenuItem
                titleLabel={t("HelpMenu_ReleasesTitle")}
                descriptionLabel={t("HelpMenu_ReleasesDesc")}
                href="https://support.impero.com/knowledge/news-releases#release-notes"
            />
            <LargeMenuItem
                titleLabel={t("HelpMenu_StatusTitle")}
                descriptionLabel={t("HelpMenu_StatusDesc")}
                href="https://status.impero.com/"
            />
        </LargeVerticalMenu>
    );
}
